import React, { useState } from 'react';
import QuotationsTable from '../components/quotation/QuotationTable';
import { fetchQuotations } from '../services/quotationService';
import NotificationSnackbar from '../components/ui/NotificationSnackbar';
import useAutoRefresh from '../hooks/useAutoRefresh';

function Quotations() {
  /* ---------------- DATA ---------------- */
  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- NOTIFICATIONS ---------------- */
  const [notif, setNotif] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const showNotification = (message, severity = 'success') => {
    setNotif({ open: true, message, severity });
  };

  /* ---------------- FETCH ---------------- */
  const loadQuotations = async ({ isAutoRefresh = false } = {}) => {
    try {
      if (!isAutoRefresh) setLoading(true);
      const data = await fetchQuotations();
      setQuotations(data);
    } catch (err) {
      console.error(err);
      showNotification('❌ Failed to load quotations', 'error');
    } finally {
      if (!isAutoRefresh) setLoading(false);
    }
  };

  useAutoRefresh(loadQuotations, { intervalMs: 20000 });

  /* ---------------- RENDER ---------------- */
  return (
    <div className="contacts-page">
      <QuotationsTable
        quotations={quotations}
        loading={loading}
        reload={loadQuotations}
        onNotify={showNotification}
      />

      <NotificationSnackbar
        open={notif.open}
        message={notif.message}
        severity={notif.severity}
        onClose={() => setNotif({ ...notif, open: false })}
      />
    </div>
  );
}

export default Quotations;
